import { useQuery } from '@tanstack/react-query'
import { getPositions } from 'api/company'
import { QueryFnParams, QueryOptions } from 'queries/types'
import { positionsKey } from './keys'

export function usePositions(
  params: Partial<QueryFnParams<typeof getPositions>[0]>,
  options: QueryOptions<typeof getPositions> = {}
) {
  const { companyId, positionType } = params

  return useQuery({
    ...options,
    queryKey: positionsKey(companyId, positionType),
    queryFn: ({ signal }) => {
      if (!companyId) {
        throw new Error('Company is required')
      }
      return getPositions({ companyId, positionType }, signal)
    },
    enabled: !!companyId && (options.enabled ?? true),
  })
}
